export const VERSION = "3.3.07"
export const MAX_FILE_SIZE = 10240 ; // 単位MB ( 10GB )
export const MAX_FILE_COUNT = 20 ; // 5個